<div class="filters-grid">
	<div class="dz-row dz-justify-content-left-lg dz-justify-content-center-sm dz-justify-content-center dz-align-items-center">
		<div class="dz-text-20-bold padding-bottom-object-2" dcrHTMLKey="FILTERS_HEADING" *ngIf="highlightedFilters?.length">FILTERS</div>
		<div class="filters margin-vertical-object-2 padding-right-object-2 dz-col-lg-4 dz-col-md-4 dz-col-sm-8 dz-col-24" *ngFor="let filter of highlightedFilters">
			<mb-filter-card [filter]="filter" [icon]="configFilters[filter.meFilterId]" [selectedFilter]="selectedFilter" (onSelect)="getSelectedFilters($event)"></mb-filter-card>
		</div>
	</div>
</div>
